import React, { useMemo } from 'react';
import styles from '../requests-table/requests-table.module.scss';
import { OrderManagementRequest } from 'core/entities';
import { RecordType } from '../requests-table/requests-table';
import { useSelector } from 'react-redux';
import { selectOfflineReportsUserAccountInfo } from 'store/offline-reports/selectors/offline-reports-selectors-factory';

type SharingDetailsProps = {
    record: RecordType | OrderManagementRequest;
};

export const SharingDetails = ({ record }: SharingDetailsProps) => {
    const { sharedDate, sharedBy } = record;
    const userAccounts = useSelector(selectOfflineReportsUserAccountInfo);
    const sharedByUserName = useMemo((): string => {
        return userAccounts?.members.find((member) => member.id === sharedBy)?.username || '';
    }, [userAccounts, sharedBy]);

    return (
        <div className={styles.dates}>
            <h3>{sharedByUserName}</h3>
            <span className={styles.firstEntity}>{sharedDate}</span>
        </div>
    );
};
